var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckoutResidentMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 20.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2988 25.6506C14.2988 26.0702 14.4636 26.4726 14.7569 26.7693C15.0501 27.0661 15.4479 27.2328 15.8627 27.2328C16.2774 27.2328 16.6752 27.0661 16.9685 26.7693C17.2617 26.4726 17.4265 26.0702 17.4265 25.6506C17.4265 25.2309 17.2617 24.8285 16.9685 24.5318C16.6752 24.2351 16.2774 24.0684 15.8627 24.0684C15.4479 24.0684 15.0501 24.2351 14.7569 24.5318C14.4636 24.8285 14.2988 25.2309 14.2988 25.6506Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9004 25.6506C22.9004 26.0702 23.0652 26.4726 23.3584 26.7693C23.6517 27.0661 24.0495 27.2328 24.4642 27.2328C24.879 27.2328 25.2767 27.0661 25.57 26.7693C25.8633 26.4726 26.028 26.0702 26.028 25.6506C26.028 25.2309 25.8633 24.8285 25.57 24.5318C25.2767 24.2351 24.879 24.0684 24.4642 24.0684C24.0495 24.0684 23.6517 24.2351 23.3584 24.5318C23.0652 24.8285 22.9004 25.2309 22.9004 25.6506Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4637 24.0695H15.8627V12.9941H14.2988",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8633 14.5781L26.8101 15.3692L26.0282 20.9069H15.8633",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutResidentMobile);
export default __webpack_public_path__ + "static/media/checkout-resident-mobile.dc1c61e644be0f806396a37db60e20cb.svg";
export { ForwardRef as ReactComponent };